module.exports = "<p class=\"text\">\n  {{ header }}\n</p>\n\n<ng-content></ng-content>"